module.exports = __webpack_public_path__ + "img/pause.352282ab.svg";